import type { IUserInfo } from "@/hooks/use-user-info";
import { getGoogleMapsDirectionUrl } from "./map-utils";
import type { LocationType } from "@/context/location-provider";

export function isValidEmail(email: string) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function isValidPhoneNumber(phone: string) {
  const phoneRegex =
    /^(?:\+?\d{1,3}[-.\s]?)?(?:\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
  return phoneRegex.test(phone);
}

export function makeCall(phone: string | null | undefined) {
  if (phone && isValidPhoneNumber(phone)) window.location.href = `tel:${phone}`;
  else console.error("Phone number not found.");
}

export function openExternalLink(
  url: string | null | undefined,
  userInfo?: IUserInfo,
) {
  const groupIdRegex = /@groupID/gi;
  const userFullNameRegex = /@userFullName/gi;
  const groupID = "@groupID";
  const userFullName = "@userFullName";

  if (url?.includes(groupID) && url?.includes(userFullName)) {
    const modifiedUrl = url
      .replace(groupIdRegex, userInfo?.groupId ?? "")
      .replace(
        userFullNameRegex,
        `${userInfo?.firstname} ${userInfo?.lastname}`,
      );
    window.open(modifiedUrl, "_blank");
  } else if (url?.includes(groupID)) {
    const modifiedUrl = url.replace(groupIdRegex, userInfo?.groupId ?? "");
    window.open(modifiedUrl, "_blank");
  } else {
    if (typeof url === "string") {
      window.open(url, "_blank");
    } else {
      console.error("URL is not valid.");
    }
  }
}

export function openEmailApp(email: string | null | undefined) {
  if (email && isValidEmail(email)) window.location.href = `mailto:${email}`;
  else console.error("Invalid email.");
}

export const getDirection = (
  providerLat: number,
  providerLng: number,
  userLocation: LocationType,
) => {
  const user = { lat: userLocation?.lat, lng: userLocation?.lng };
  const provider = { lat: providerLat, lng: providerLng };
  const url = getGoogleMapsDirectionUrl(user, provider, "driving");
  window.open(url, "_blank");
};
